import { createAsyncThunk } from '@reduxjs/toolkit'
import { SOMETHING_WHEN_WRONG } from 'constant/errorMessages'
import { ReplenishmentV3QueryType } from 'features/SupplyOrder/@types/ReplenishmentV3'
import { getReplenishmentTaskV3 } from 'features/SupplyOrder/services/replenishmentV3'
import { callErrorMsg } from 'helpers/errorMsg'

export const SLICE_NAME = 'REPLENISHMENT_PUTAWAY'

export const fetchReplenishmentPutawayTask = createAsyncThunk(
  `${SLICE_NAME}/fetchReplenishmentPutawayTask`,
  async (params: ReplenishmentV3QueryType, { rejectWithValue }) => {
    try {
      const response = await getReplenishmentTaskV3(params)

      return response.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)
